export default __webpack_public_path__ + "static/media/Ace_Prospectus.6f0eb030.pdf";